// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3MbVD","itemTitle":"ClientEmergencyInfo_itemTitle__1GKtd","itemText":"ClientEmergencyInfo_itemText__p5UdL"};